import AppBarComponent from '../../components/AppBarComponent';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import ScrollToTop from '../../components/ScrollToTop';
import Chatbot from '../ChatbotBedrock';

function PrivateLayout({ user }: any) {
    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
            <ScrollToTop />
            <CssBaseline />
            <AppBarComponent user={user} />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: { xs: 2, md: 4 },
                    pt: { xs: '80px', md: '104px' }, // Adjust padding top to account for AppBar
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                <Chatbot />
            </Box>
        </Box>
    );
}

export default PrivateLayout;